import { createSlice } from '@reduxjs/toolkit';

interface LogEntriesState {
  logEntries: any[];
}

const initialState: LogEntriesState = {
  logEntries: [],
};

const logEntriesSlice = createSlice({
  name: 'logEntries',
  initialState,
  reducers: {
    setLogEntires: (state, action) => {
      state.logEntries = action.payload;
    },
  },
});

export const { setLogEntires } = logEntriesSlice.actions;

export default logEntriesSlice.reducer;
